import React from 'react';
import { Box, Button, CssBaseline, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import routes from '../config/routes';

export default function PageNotFound() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <CssBaseline />
      <Typography variant="h1">404</Typography>
      <Typography mt="16px" variant="h4">
        Page not found.
      </Typography>
      <Typography align="center" mt="8px" mb="16px" variant="body1">
        The page you are looking for does not exist. You can click the button
        below to go back to the homepage.
      </Typography>
      <Link to={routes.users.path}>
        <Button variant="outlined">Homepage</Button>
      </Link>
    </Box>
  );
}
